import {metadaApi} from '@dms/api/base';

import {
  GetLabourUnitRequest,
  GetLabourUnitRequestSchema,
  GetLabourUnitResponse,
  GetLabourUnitResponseSchema,
  GetLabourUnitsRequest,
  GetLabourUnitsRequestSchema,
  GetLabourUnitsResponse,
  GetLabourUnitsResponseSchema,
  PatchLabourUnitRequest,
  PatchLabourUnitRequestSchema,
  PatchLabourUnitResponse,
  PatchLabourUnitResponseSchema,
  PostLabourUnitRequest,
  PostLabourUnitRequestSchema,
  PostLabourUnitResponse,
  PostLabourUnitResponseSchema,
  DeleteLabourUnitRequest,
  DeleteLabourUnitRequestSchema,
  DeleteLabourUnitResponse,
  DeleteLabourUnitResponseSchema,
  SetLabourUnitAsDefaultRequest,
  SetLabourUnitAsDefaultRequestSchema,
  SetLabourUnitAsDefaultResponse,
  SetLabourUnitAsDefaultResponseSchema,
} from './types';

export const metadaWorkshopLabourUnitApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getLabourUnits: build.query<GetLabourUnitsResponse, GetLabourUnitsRequest>({
      query: () => ({
        url: `service/v1/labour-unit`,
        method: 'GET',
      }),
      providesTags: ['labourUnits'],
      extraOptions: {
        requestSchema: GetLabourUnitsRequestSchema,
        responseSchema: GetLabourUnitsResponseSchema,
      },
    }),
    getLabourUnit: build.query<GetLabourUnitResponse, GetLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [{type: 'labourUnits', id: queryArg.labourUnitId}],
      extraOptions: {
        requestSchema: GetLabourUnitRequestSchema,
        responseSchema: GetLabourUnitResponseSchema,
      },
    }),
    postLabourUnit: build.mutation<PostLabourUnitResponse, PostLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit`,
        method: 'POST',
        body: queryArg,
        invalidatesTags: ['labourUnits'],
        queryArg,
      }),
      extraOptions: {
        requestSchema: PostLabourUnitRequestSchema,
        responseSchema: PostLabourUnitResponseSchema,
      },
    }),
    patchLabourUnit: build.mutation<PatchLabourUnitResponse, PatchLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourUnits', id: queryArg.labourUnitId},
      ],
      extraOptions: {
        requestSchema: PatchLabourUnitRequestSchema,
        responseSchema: PatchLabourUnitResponseSchema,
      },
    }),
    postLabourUnitActive: build.mutation<PatchLabourUnitResponse, PatchLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}/set-active`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourUnits', id: queryArg.labourUnitId},
      ],
      extraOptions: {
        requestSchema: PatchLabourUnitRequestSchema,
        responseSchema: PatchLabourUnitResponseSchema,
      },
    }),
    postLabourUnitInactive: build.mutation<PatchLabourUnitResponse, PatchLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}/set-inactive`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourUnits', id: queryArg.labourUnitId},
      ],
      extraOptions: {
        requestSchema: PatchLabourUnitRequestSchema,
        responseSchema: PatchLabourUnitResponseSchema,
      },
    }),
    deleteLabourUnit: build.mutation<DeleteLabourUnitResponse, DeleteLabourUnitRequest>({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: ['labourUnits'],
      extraOptions: {
        requestSchema: DeleteLabourUnitRequestSchema,
        responseSchema: DeleteLabourUnitResponseSchema,
      },
    }),
    setLabourUnitAsDefault: build.mutation<
      SetLabourUnitAsDefaultResponse,
      SetLabourUnitAsDefaultRequest
    >({
      query: (queryArg) => ({
        url: `service/v1/labour-unit/${queryArg.labourUnitId}/set-default`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: ['labourUnits'],
      extraOptions: {
        requestSchema: SetLabourUnitAsDefaultRequestSchema,
        responseSchema: SetLabourUnitAsDefaultResponseSchema,
      },
    }),
  }),
});

export const {
  useGetLabourUnitsQuery,
  useGetLabourUnitQuery,
  usePostLabourUnitMutation,
  usePatchLabourUnitMutation,
  usePostLabourUnitActiveMutation,
  usePostLabourUnitInactiveMutation,
  useDeleteLabourUnitMutation,
  useSetLabourUnitAsDefaultMutation,
} = metadaWorkshopLabourUnitApi;
